/**
 * AccuCore toast notification system powered by sonner.
 *
 * Usage:
 *   import { toast } from './toast.js'
 *   toast.success('Saved!')
 *   toast.error(error.message)
 *   toast.info('Processing…')
 *
 * Add <Toaster /> once at the app root (main.tsx or App layout).
 */

import { Toaster as SonnerToaster } from 'sonner';
export { toast } from 'sonner';

/** Pre-configured Toaster for AccuCore dark theme */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      theme="dark"
      richColors
      expand={false}
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast: 'font-sans text-sm',
        },
      }}
    />
  );
}
